if (!customElements.get('brands-visual-identity')) {
  customElements.define(
    'brands-visual-identity',
    class BrandsVisualIdentity extends HTMLElement {
      constructor() {
        super();
        this.proofButtons = this.querySelectorAll('.identity-card__proof-toggle');
        this.proofAccordions = this.querySelectorAll('.identity-proof-accordion');
        this.navButtons = this.querySelectorAll('.proof-nav-button');
        this.currentSlideIndex = {};
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.minSwipeDistance = 50; // Minimum distance for swipe to register
      }

      connectedCallback() {
        this.initProofButtons();
        this.initNavigationButtons();
        this.initSlideIndexes();
        this.initTouchSwipe();
      }

      initSlideIndexes() {
        this.proofAccordions.forEach(accordion => {
          const blockId = accordion.dataset.blockId;
          this.currentSlideIndex[blockId] = 0;
        });
      }

      initProofButtons() {
        this.proofButtons.forEach(button => {
          button.addEventListener('click', this.handleAccordionToggle.bind(this));
        });
      }

      initNavigationButtons() {
        this.navButtons.forEach(button => {
          button.addEventListener('click', this.handleNavigation.bind(this));
        });
      }

      initTouchSwipe() {
        this.proofAccordions.forEach(accordion => {
          const slidesWrapper = accordion.querySelector('.proof-slides-wrapper');
          if (slidesWrapper) {
            slidesWrapper.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
            slidesWrapper.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
          }
        });
      }

      handleTouchStart(event) {
        this.touchStartX = event.changedTouches[0].screenX;
      }

      handleTouchEnd(event) {
        this.touchEndX = event.changedTouches[0].screenX;
        this.handleSwipeGesture(event.currentTarget);
      }

      handleSwipeGesture(slidesWrapper) {
        const swipeDistance = this.touchEndX - this.touchStartX;
        
        // Check if swipe distance is significant enough
        if (Math.abs(swipeDistance) < this.minSwipeDistance) return;
        
        const blockId = slidesWrapper.dataset.blockId;
        const slides = slidesWrapper.querySelectorAll('.proof-slide');
        const activeSlide = slidesWrapper.querySelector('.proof-slide.is-active');
        
        if (!activeSlide || slides.length <= 1) return;
        
        const currentIndex = parseInt(activeSlide.dataset.slideIndex);
        let nextIndex;
        
        // Swipe left (next slide) - loops back to first
        if (swipeDistance < 0) {
          nextIndex = currentIndex < slides.length - 1 ? currentIndex + 1 : 0;
        }
        // Swipe right (previous slide) - loops to last
        else if (swipeDistance > 0) {
          nextIndex = currentIndex > 0 ? currentIndex - 1 : slides.length - 1;
        } else {
          return; // No valid swipe
        }
        
        // Hide current slide
        activeSlide.classList.remove('is-active');
        
        // Show next slide
        slides[nextIndex].classList.add('is-active');
        
        // Update button states (for desktop)
        this.updateNavigationButtons(blockId, nextIndex, slides.length);
      }

      handleAccordionToggle(event) {
        const button = event.currentTarget;
        const blockId = button.dataset.blockId;
        const accordion = this.querySelector(`#ProofAccordion-${blockId}`);

        if (accordion) {
          const isOpen = accordion.classList.contains('is-open');
          
          if (isOpen) {
            this.closeAccordion(accordion, button);
          } else {
            // Close any other open accordions first
            this.closeAllAccordions();
            this.openAccordion(accordion, button);
          }
        }
      }

      handleNavigation(event) {
        const button = event.currentTarget;
        const blockId = button.dataset.blockId;
        const isPrev = button.classList.contains('proof-nav-prev');
        
        const slidesWrapper = this.querySelector(`.proof-slides-wrapper[data-block-id="${blockId}"]`);
        if (!slidesWrapper) return;
        
        const slides = slidesWrapper.querySelectorAll('.proof-slide');
        const activeSlide = slidesWrapper.querySelector('.proof-slide.is-active');
        
        if (!activeSlide || slides.length <= 1) return;
        
        const currentIndex = parseInt(activeSlide.dataset.slideIndex);
        let nextIndex;
        
        if (isPrev) {
          nextIndex = currentIndex > 0 ? currentIndex - 1 : slides.length - 1;
        } else {
          nextIndex = currentIndex < slides.length - 1 ? currentIndex + 1 : 0;
        }
        
        // Hide current slide
        activeSlide.classList.remove('is-active');
        
        // Show next slide
        slides[nextIndex].classList.add('is-active');
        
        // Update button states
        this.updateNavigationButtons(blockId, nextIndex, slides.length);
      }

      updateNavigationButtons(blockId, currentIndex, totalSlides) {
        // Looping behavior: arrows are always enabled
        // No disabled state needed as slider loops continuously
      }

      openAccordion(accordion, button) {
        accordion.classList.add('is-open');
        button.classList.add('is-open');
        
        // Set max-height to actual content height for smooth animation
        const content = accordion.querySelector('.proof-accordion__content');
        if (content) {
          accordion.style.maxHeight = content.scrollHeight + 'px';
        }
        
        // Initialize navigation buttons
        const blockId = accordion.dataset.blockId;
        const slidesWrapper = accordion.querySelector('.proof-slides-wrapper');
        if (slidesWrapper) {
          const slides = slidesWrapper.querySelectorAll('.proof-slide');
          this.updateNavigationButtons(blockId, 0, slides.length);
        }
      }

      closeAccordion(accordion, button) {
        accordion.classList.remove('is-open');
        if (button) {
          button.classList.remove('is-open');
        }
        accordion.style.maxHeight = '0';
      }

      closeAllAccordions() {
        this.proofAccordions.forEach(accordion => {
          const blockId = accordion.dataset.blockId;
          const button = this.querySelector(`.identity-card__proof-toggle[data-block-id="${blockId}"]`);
          this.closeAccordion(accordion, button);
        });
      }

      disconnectedCallback() {
        this.proofButtons.forEach(button => {
          button.removeEventListener('click', this.handleAccordionToggle);
        });
        this.navButtons.forEach(button => {
          button.removeEventListener('click', this.handleNavigation);
        });
        this.proofAccordions.forEach(accordion => {
          const slidesWrapper = accordion.querySelector('.proof-slides-wrapper');
          if (slidesWrapper) {
            slidesWrapper.removeEventListener('touchstart', this.handleTouchStart);
            slidesWrapper.removeEventListener('touchend', this.handleTouchEnd);
          }
        });
      }
    }
  );
}
